import {Button, Tab, TabsPanel, Tooltip, icon} from '@hm/fundamental'
import React from 'react'

import {type FlowSetup} from '../types'

interface FlowTabsProps {
  setups: FlowSetup[]
  selectedSetupId: string
  onSetupSelect: (setupId: string) => void
  onCreateSetup: () => void
  onDeleteSetup: () => void
  canCreateSetup: boolean
  canDeleteSetup: boolean
  getSetupLabel: (index: number) => string
  createLabel: string
  deleteLabel: string
  limitReachedLabel: string
}

export const FlowTabs: React.FC<FlowTabsProps> = ({
  setups,
  selectedSetupId,
  onSetupSelect,
  onCreateSetup,
  onDeleteSetup,
  canCreateSetup,
  canDeleteSetup,
  getSetupLabel,
  createLabel,
  deleteLabel,
  limitReachedLabel
}) => {
  return (
    <div className="flex flex-row justify-between items-end">
      <TabsPanel
        key={selectedSetupId}
        onSelect={(value) => onSetupSelect(value)}
        className="!p-0"
        data-cy="flow-setup-tabs"
      >
        {setups.map((setup, index) => (
          <Tab
            key={setup.id}
            label={getSetupLabel(index)}
            value={setup.id}
            isActive={selectedSetupId === setup.id}
            data-cy={`flow-setup-tab-${setup.id}`}
          />
        ))}
      </TabsPanel>
      <div className="flex flex-row gap-2 items-center pb-1">
        {canDeleteSetup && (
          <Button
            variant="tertiary"
            size="small"
            icon={icon.mdiDeleteOutline}
            colorClass="text-negative hover:bg-negative_faded_10"
            onClick={onDeleteSetup}
          >
            {deleteLabel}
          </Button>
        )}
        {canCreateSetup ? (
          <Button
            variant="tertiary"
            size="small"
            onClick={onCreateSetup}
            data-cy="flow-create-setup"
          >
            {`+ ${createLabel}`}
          </Button>
        ) : (
          <div className="[&_[data-cy=tooltip-content]]:!-translate-x-[85%]">
            <Tooltip content={limitReachedLabel} delayMs={0}>
              <Button variant="tertiary" size="small" disabled data-cy="flow-create-setup-disabled">
                {`+ ${createLabel}`}
              </Button>
            </Tooltip>
          </div>
        )}
      </div>
    </div>
  )
}
